// https://www.axllent.org/docs/view/track-outbound-links-with-analytics-js/#manually-track-outbound-links
// Hacky script to track outbound links.

(function () {
    function _gaLt(event) {
        if (typeof gtag === "undefined") {
            console.debug('gtag is disabled.');
            return;
        }

        /* Not main|middle|touch click then don't track */
        if (event.which != 1 && event.which != 2) {
            return;
        }

        var el = event.srcElement || event.target;

        /* Loop up the DOM tree through parent elements if clicked element is not a link (eg: an image inside a link) */
        while (el && (typeof el.tagName == 'undefined' || el.tagName.toLowerCase() != 'a' || !el.href)) {
            el = el.parentNode;
        }

        /* if a link with valid href has been clicked */

        if (el && el.href && !el.hasAttribute('data-no-tracking')) {
            var link = el.href;

            /* Only if it is an external link */
            if (link.indexOf(location.host) == -1 && !link.match(/^javascript\:/i)) {

                /* Is actual target set and not _(self|parent|top)? */
                var target = (el.target && !el.target.match(/^_(self|parent|top)$/i)) ? el.target : false;

                /* Assume a target if Ctrl|shift|meta-click */
                if (event.ctrlKey || event.shiftKey || event.metaKey || event.which == 2) {
                    target = "_blank";
                }

                var hbrun = false; // tracker has not yet run

                /* HitCallback to open link in same window after tracker */
                var hitBack = function () {
                    /* run once only */
                    if (hbrun) return;
                    hbrun = true;
                    window.location.href = link;
                };

                if (target) { /* If target opens a new window then just track */
                    console.log('click:outbound:track', link);
                    gtag('event', 'click', {
                        'event_category': 'outbound',
                        'event_label': link
                    });
                } else { /* Prevent standard click, track then open */
                    event.preventDefault ? event.preventDefault() : event.returnValue = !1;
                    /* send event with callback */

                    console.log('click:outbound:beacon', link);

                    gtag('event', 'click', {
                        'event_category': 'outbound',
                        'event_label': link,
                        'transport_type': 'beacon',
                        'event_callback': hitBack
                    });

                    /* Run hitCallback again if GA takes longer than 1 second */
                    setTimeout(hitBack, 1000);
                }
            }
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        document.body.addEventListener(("ontouchstart" in window) ? "click" : "mousedown", _gaLt, !1)
    });
}());
